
import { ApiMethods, AxiosClient } from "@/api/ApiClient";
import { ApiEndpoints } from "@/api/ApiEndpoints";
import { Values } from "@/constants/Values";
import { createFormData } from "@/lib/utils";
import { BillingCycle, SelectablePlan } from "@/types/monetisationTypes";
import { VenueAddressType,GenerateForgotPasswrodLinkForVendor,UpdateVendorVenueSlotsPayloadType,CreateWebsiteType,SignUpEmailVerificationPayload, ToggalBookingType,Sports, Court, DeleteImagesType, CreateOrderPaymentType, verifyPayment, GetSlotsByDatePayload, createRecommendationType ,ManulBookingPayload, DirectBookingPayload, CreateVendorDiscountType, rescheduleBookingType} from "@/types/interfaceType"
export interface LoginPayload {
  phone?: number,
  email?: string,
  password?: string
}

export interface SignUpPayload {
  firstName: string,
  lastName: string,
  email: string,
  phone: any,
  password: string,
  otp:string
}

export interface SendVendorOTPpayload {
  email?: string,
  phoneNumber?: string
}

export interface VerifyVendorOTPpayload {
  email?: string,
  phoneNumber?: string,
  otp: string
}


export interface registerNewVenuePayload {
  name: string,
  baseBookingPricePerHour: number
  description: string,
  amenities: string[]
}

export interface updateVenuePayload {
  name?: string,
  baseBookingPricePerHour?: number
  description?: string,
  amenities?: string[],

  address?: VenueAddressType

  sportsCategories?: string[]
  sports?: Sports[],

  allowCancellationOfBooking?: boolean,
  cancellationBeforeTime_InHours?: number

}

export interface updateVenuePayload {
  name?: string,
  baseBookingPricePerHour?: number
  description?: string,
  amenities?: string[],

  address?: VenueAddressType

  sportsCategories?: string[]
  sports?: Sports[],
  groundConfig?:String,
  allowCancellationOfBooking?: boolean,
  cancellationBeforeTime_InHours?: number

}


export interface UpdateVendorSportAndCourtOnEditPayload {
  sportId?: string,
  courtId?: string,
  venueId: string,
  updateData: Sports;
}


export interface updateVendorProfilePayload {
  address?: {
    address: string,
    locality: string,
    city: string,
    state: string,
    pincode: any
  },
  bankDetails?: {
    accountHolderName: string,
    bankName: string,
    accountNumber: string,
    ifsc: string,
    upiId: string,
  }
}
export interface OtpVerificationPayload {
  username: string;
  otp: string;
}

export type UploadUsersPayload = {
  file: string;
  metadata: {
    attributeMapping: {
      [key: string]: string
    }
  }
}

export interface WriteReviewInterface {
  venueId: string,
  bookingId: string,
  rating: number
  comment?: string
}


const ApiBuilder = {
  //user


  login: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.vendorusernameandpasswordlogin,
      data: data
      // data,
    });
  },

  getVendorProfile: async (token: string) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorProfile,
      token: token
    });
  },

  getCustomerByPhone:async (pathparams: String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getCustomerByPhone,
      pathParam:pathparams
    });
  },

  updateVendorProfile: async (data: updateVendorProfilePayload) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.updateVendorProfile,
      data
    });
  },

  updateturfImages: async (data: FormData) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.updateturfImages,
      data,
      isFormData: true
    });
  },
  deleteImages: async (data: DeleteImagesType) => {
    return await AxiosClient({
      method: ApiMethods.DELETE,
      url: ApiEndpoints.deleteImages,
      data,
    });
  },


  sendVendorSignupOtpToEmail: async (data: SignUpEmailVerificationPayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.sendVendorSignupOtpToEmail,
      data: data
      // data,
    });
  },
  signUpVendor: async (data: SignUpPayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.onboardvendor,
      data: data
      // data,
    });
  },

  sendVendorOTP: async (data: SendVendorOTPpayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.sendVendorOTP,
      data: data
      // data,
    });
  },

  verifyVendorOTP: async (data: VerifyVendorOTPpayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyVendorOTP,
      data: data
    });
  },

  verifyOtp: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.login,
      data: data
      // data,
    });
  },


  registerNewVenue: async (data: registerNewVenuePayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.registerNewVenue,
      data: data
    });
  },

  venueUpdateById: async (data: updateVenuePayload, pathParam: String) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.venueUpdateById,
      data: data,
      pathParam: pathParam
    });
  },

  deleteSportById: async (data:{sportId:String}, pathParam: String) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.deleteSportById,
      data: data,
      pathParam: pathParam
    });
  },


  getPendingVenueDetails: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getPendingVenueDetails,
    });
  },


  getCompletedVenueDetails: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getCompletedVenueDetails,
    });
  },

  getVendorVenueDetailsById: async (pathparams: String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorVenueDetailsById,
      pathParam: pathparams
    });
  },

  updateVendorSportAndCourtOnEdit: async (data: UpdateVendorSportAndCourtOnEditPayload) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.updateVendorSportAndCourtOnEdit,
      data
    });
  },



  addNewCourtInVendorSports: async (data: {
    venueId: string,
    sportId: string,
    courtData: Court
  }) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.addNewCourtInVendorSports,
      data
    });
  },
  logout: async () => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.login,
      // data,
    });
  },


  //Payment

  createPaymentOrder: async (data: CreateOrderPaymentType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createOnboardingPaymentOrder,
      data,
    });

  },


  verifyOnboardingPayment: async (data: verifyPayment) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyOnboardingPayment,
      data,
    });

  },


  createPaymentOrderForDirectBookingLinkSubscription: async (data: CreateOrderPaymentType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createPaymentOrderForDirectBookingLinkSubscription,
      data,
    });

  },


  verifyDirectBookingLinkSubscriptionPayment: async (data: verifyPayment) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyDirectBookingLinkSubscriptionPayment,
      data,
    });

  },

  getVendorDirectBookingLinkVenuesSubscription:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorDirectBookingLinkVenuesSubscription,
    });

  },


  getSubscriptionPlanDetails:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getSubscriptionPlanDetails,
    });

  },

  getSlotsByDate: async (data: GetSlotsByDatePayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getSlotsByDate,
      data,
    });
  },

  updateVendorVenueSlots:async (data: UpdateVendorVenueSlotsPayloadType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.updateVendorVenueSlots,
      data,
    });
  },

  toggleBookingByVenueId:async (pathparams: String,payload:ToggalBookingType) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.toggleBookingByVenueId,
      pathParam: pathparams,
      data:payload
    });
  },

  createwebsite:async (payload:CreateWebsiteType) => {
    const formData = createFormData(payload);
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createwebsite,
      data:formData,
      isFormData:true
    });
  },

  getWebsiteByVendor:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getWebsiteByVendor,
      showCustomError:false
    });
  },


  vendorDashboardDetails:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.vendorDashboardDetails,
    });
  },



  //Venues

  venuesList: async (payload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.venuesList,
      data: payload,
      // data,
    });
  },

  venueDetailsList: async (params: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVenueDetails,
      pathParam: params
    });
  },

  getProfile: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getProfile,
    });
  },

  updateUserProfile: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.updateUserProfile,
      data
    });
  },

  getStaticPaymentFeeDetails: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getStaticPlatformFeeConfig,
    });
  },

  getStaticConfig: async (pathParam: String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getStaticConfig,
      pathParam: pathParam
    });
  },

  createBooking: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createBooking,
      data
    });
  },
  cancelBooking: async (params: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.cancelBooking,
      pathParam: params
    });
  },
  cancelPendingBooking: async (params: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.cancelPendingBooking,
      pathParam: params
    });
  },
  getMyBookings: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getMyBookings,
    });
  },
  getUserPendingBookings: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getUserPendingBookings,
    });
  },

  verifyPayment: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyPayment,
      data
    });
  },

  getCategories: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getCategories,
    });
  },

  getNearbyTurfs: async (payload: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getNearbyVenues,
      data: payload
    });
  },

  writeReview: async (payload: WriteReviewInterface) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.writeReview,
      data: payload
    });
  },
  getAllReviews: async (queryParams: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getAllReviews,
      data: queryParams
    });
  },
  createVendorFundAccount:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.createVendorFundAccount,
    });
  },
  validateVendorBankAccount:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.validateVendorBankAccount,
    });
  },
  generateForgotPasswrodLinkForVendor:async(data:GenerateForgotPasswrodLinkForVendor)=>{
  return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.generateForgotPasswrodLinkForVendor,
      data:data
    });
  },

  getVendorPromotions:async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorPromotions,
    });
  },

  createRecommendation:async(data:createRecommendationType)=>{
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createRecommendation,
      data:data
    });
  },

  verifyRecommendationSubscriptionPayment: async (data: verifyPayment) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyRecommendationSubscriptionPayment,
      data,
    });
  },

  createManualBooking: async (data: ManulBookingPayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createManualBooking,
      data,
    });
  },

  createDirectBooking: async (data: DirectBookingPayload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createDirectBooking,
      data,
    });
  },

  cancelManualBooking:async (bookingId:string) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.cancelVendorManualBooking,
      pathParam:bookingId,
    });
  },


  getVendorsBookingsWithPagination: async (queryParams:{page:number,limit:number,status?:any,bookingSource?:string}) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorsBookingsWithPagination,
      data:queryParams?queryParams:{page:1,limit:Values.BookingLimit},
      showHeaderToast:false
    });
  },

  getVendorsBookingsDetailsWithID: async (pathParam:String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorsBookingsDetailsWithID,
      pathParam,
      showHeaderToast:false
    });
  },



    getVendorDiscounts: async (queryParams:{page:number,limit:number,status?:string}) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVendorDiscounts,
      data:queryParams,
      showHeaderToast:false
    });
  },

    createVendorDiscount: async (data:CreateVendorDiscountType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createVendorDiscount,
      data,
      showHeaderToast:false
    });
  },

    toggleVendorDiscount: async (pathParam:String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.toggleVendorDiscount,
      pathParam,
      showHeaderToast:false
    });
  },



    deleteVendorDiscount: async (pathParam:String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.deleteVendorDiscount,
      pathParam,
      showHeaderToast:false
    });
  },

    rescheduleBooking:async (data:rescheduleBookingType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.rescheduleBooking,
      data,
      showHeaderToast:true
    });
  },

  checkAgreementStatus:async (data:{venueId:string}) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.checkAgreementStatus,
      data,
      showHeaderToast:true
    });
  },



  /* --------------------------------------------------------- monetisation */

  getMonetisationPlans: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.monetisationPlans,
    });
  },

  getVenueMonetisation: async (venueId: String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: `${ApiEndpoints.monetisationVenue}/${venueId}`,
    });
  },

  /** Cycle price only — no listing fee. Use goLiveQuote before a venue is live. */
  getSubscriptionQuote: async (venueId: String, data: { billingCycle: BillingCycle }) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: `${ApiEndpoints.monetisationVenue}/${venueId}/quote`,
      data,
    });
  },

  getGoLiveQuote: async (venueId: String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: `${ApiEndpoints.goLiveQuote}/${venueId}`,
    });
  },

  subscribeVenue: async (venueId: String, data: { billingCycle: BillingCycle }) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: `${ApiEndpoints.monetisationVenue}/${venueId}/subscribe`,
      data,
    });
  },

  switchVenuePlan: async (
    venueId: String,
    data: { toPlan: SelectablePlan; billingCycle?: BillingCycle; reason?: string },
  ) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: `${ApiEndpoints.monetisationVenue}/${venueId}/switch-plan`,
      data,
    });
  },

  cancelScheduledPlanSwitch: async (venueId: String) => {
    return await AxiosClient({
      method: ApiMethods.DELETE,
      url: `${ApiEndpoints.monetisationVenue}/${venueId}/switch-plan`,
    });
  },

  abandonAuthorisation: async (venueId: String, data?: { reason?: string }) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: `${ApiEndpoints.monetisationVenue}/${venueId}/abandon-authorisation`,
      data: data || {},
      // Fired from a checkout the vendor closed; a failure here is housekeeping,
      // not something to interrupt them about.
      showCustomError: false,
    });
  },
};



export default ApiBuilder;
